import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getPatient } from 'api/Patients';
import { getPatientDashboardAppointments } from 'api/Appointment';

import { toNumericId } from 'lib/helpers/utility';

export const usePatient = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(
    ['patient', ...dependencies.map(toNumericId)],
    () => getPatient(navigate, params),
    {
      refetchOnWindowFocus: false,
      enabled: !!params?.id,
      ...options
    }
  );
};

export const usePatientDashboardAppointments = ({
  params = {},
  options = {},
  dependencies = []
}) => {
  const navigate = useNavigate();
  return useQuery(
    ['patient-dashboard-appointments', params, ...dependencies],
    () => getPatientDashboardAppointments(navigate, params),
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: 1000 * 60 * 5, // 5 minutes
      ...options
    }
  );
};
